function mergeRows(matrix, i, j, func, overlap) {
	if (i === j) throw new Error("Index i equals index j. Cannot merge matrix row with itself.");
	const rowA = matrix[i];
	const rowB = matrix[j];
	const rowAB = [];
	for (let k = 0; k < rowA.length; k++) if (k !== i && k !== j) rowAB.push(func(rowA[k], rowB[k]));
	rowAB.push(overlap);
	matrix.splice(Math.max(i, j), 1);
	matrix.splice(Math.min(i, j), 1);
	matrix.forEach((row) => {
		row.splice(Math.max(i, j), 1);
		row.splice(Math.min(i, j), 1);
	});
	matrix.forEach((row, k) => row.push(rowAB[k]));
	matrix.push(rowAB);
}
export { mergeRows };

//# sourceMappingURL=index91.js.map